import React                      from 'react'
import { Observer }               from 'mobx-react'
import { InputNumber }            from 'antd'

import { TEXT, tr_enum_key_application }                   from '../00_assets'
import { kde_api_job_t }          from '../02_api'
import { Biting
       , FormElement
       , FormError
       , FormField
       , form_model
       , IFormEditor
       , IFormEditorModel
       , SelectMachine
       , FIELD_TYPE
       , VALID }                  from '../10_ui'


export function create_job_editor_model ( job: kde_api_job_t )
{
  const fields =
    { quantity : { label: TEXT.JOB_QUANTITY
                 , init: job.quantity
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 }
    , machine_id: { label: TEXT.MACHINE_NAME
                 , init: job.machine!.id
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 }
    , key      : { label: TEXT.MACHINE_TYPE
                 , init: job.key
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_num
                 , required: true
                 }
    , title    : { label: TEXT.WORKGROUPS_NAME
                 , init: job.machine? job.machine.name : ''
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_num
                 , required: true
                 }
  }

  return form_model( fields
                   , ( data: IFormEditorModel ) =>
                     ({ quantity: data.quantity.value( )
                      , machine: { id: data.machine_id.value( ) } 
                      })
                   ) ;
}


export const JobEditor: React.FC< { form: IFormEditor } > = ( props ) =>
<Observer render={ ( ) => 
{ 
  const form = props.form
      , key  = form.model.key.value( )
      , show_data = ( title: TEXT, value: any, className?: string  ) =>
          <FormElement label={ title }>
            <span className={ className } style={{ lineHeight: '33px' }}>{ value }</span>
          </FormElement> ;

  return <>
      <h3 className="mt-3">{ form.model.title.value( ) }</h3>
      <FormField field={ form.model.quantity }>
        <InputNumber 
           className="text-right w-100"
           min={1} 
           { ...form.model.quantity.bind( ) }
         />
      </FormField>
      
      <FormField field={ form.model.machine_id  }>
        <SelectMachine 
          { ...form.model.machine_id.bind( ) }
          className="text-right w-100"
        />
      </FormField>
      { show_data( TEXT.KEY_MODEL      , key.model, 'text-mono' ) }
      { show_data( TEXT.KEY_SERIES     , key.series ) }
      { show_data( TEXT.KEY_CODE       , key.code ) }
      { show_data( TEXT.KEY_DATA_SHEET , key.datasheet.id ) }
      { show_data( TEXT.KEY_BITING     , <Biting value={key.biting} /> ) }
      { show_data( TEXT.KEY_APPLICATION, tr_enum_key_application( key.application.name ) ) }
      <FormError has={ form.show_error( ) } />
    </> ;
} } /> ;
